import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";
import { Link } from "react-router-dom";

const Project = () => {
  const [categories, setCategories] = useState();
  useEffect(() => {
    fetch("https://nahid-parvez-server.vercel.app/categories")
      .then((res) => res.json())
      .then((data) => setCategories(data));
  }, []);
  return (
    <section id="projects" className="py-10 text-white">
      <div className="text-center">
        <h3 className="text-4xl font-semibold">
          My <span className="text-indigo-600">Projects</span>
        </h3>
      </div>
      <br />
      <div className="flex max-w-6xl gap-6 px-5 mx-auto items-center relative">
        <div className="w-full">
          <Swiper
            slidesPerview={1.2}
            spaceBetween={20}
            breakpoints={{
              768: {
                slidesPerView: 3,
              },
            }}
            loop={true}
            autoplay={{
              delay: 5000,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination, Autoplay]}
          >
            {categories?.map((project_info, i) => (
              <SwiperSlide key={i}>
                <div className="h-auto w-full p-4 bg-slate-800 rounded-xl mb-10 transform transition duration-500 hover:scale-105 hover:shadow-2xl shadow-black">
                  <img src={project_info.img} alt="" className="rounded-lg" />
                  <h3 className="text-xl mt-2">{project_info.name}</h3>
                  <p className="mb-4 text-gray-400">
                    {project_info.description} <br /> <br />
                    {project_info.one} <br />
                    {project_info.two} <br />
                  </p>
                  <div>
                    <Link to={`/project/${project_info.id}`}>
                      <button className="px-10 py-2 border-2 rounded-md border-indigo-700 hover:bg-indigo-700 transition duration-500">
                        Explore More
                      </button>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Project;
